<template>
    <div>
        <sbpps-faculty-icard v-if="tenant == 'sbpps'" />
        <zeal-faculty-icard v-else-if="tenant == 'zeal'" />
        <sanjivani-faculty-icard v-else-if="tenant == 'sanjivani'" />
        <veis-faculty-icard v-else-if="tenant == 'veis'" />
        <wws-faculty-icard v-else-if="tenant == 'wws' || 'uwws' || 'vvp'" />
        <tmv-faculty-icard v-else-if="tenant == 'tmvidyalaya'" />
        <eps-faculty-icard v-else-if="tenant == 'eps'" />
        <div v-else>
            Under Development.....
        </div>
    </div>
</template>

<script>
// import sbpps_faculty_icard from './SbppsInstructorIcard.vue'
// import zeal_faculty_icard from './ZealInstructorIcard.vue'
// import veis_faculty_icard from './VeisInstructorIcard.vue'
// import wws_faculty_icard from './WwsInstructorIcard.vue'
// import eps_faculty_icard from './EpsInstructorIcard.vue'
export default {
    components: {
        'sbpps-faculty-icard': () => import('./SbppsInstructorIcard'),
        'zeal-faculty-icard': () => import('./ZealInstructorIcard'),
        'sanjivani-faculty-icard': () => import('./SanjivaniInstructorIcard'),
        'veis-faculty-icard': () => import('./VeisInstructorIcard'),
        'wws-faculty-icard': () => import('./CommonInstructorIcard'),
        'tmv-faculty-icard': () => import('./CommonInstructorIcard'),
        'eps-faculty-icard': () => import('./EpsInstructorIcard'),
    },
    data: () => ({
        tenant: null
    }),
    created() {
        this.tenant = localStorage.getItem("EPS-tenant")
    },
    mounted() {

    }
}
</script>

<style></style>